const EVENT_DETAIL_MAP = {
    LEAGUE_NAME: 2,
    EVENT_NAME: 4
}

const AVERAGE_STATISTICS_ROW_TITLE_MAP = [
    {
        TITLE: 'Goals scored',
        INDEX: 0
    },
    {
        TITLE: 'Goals conceded',
        INDEX: 1
    },
    {
        TITLE: 'Time first goal scored',
        INDEX: 2
    },
    {
        TITLE: 'Time first goal conceded',
        INDEX: 3
    },
    {
        TITLE: 'Yellow cards',
        INDEX: 4
    },
    {
        TITLE: 'Red cards',
        INDEX: 5
    },
    {
        TITLE: 'Average # corners per game',
        INDEX: 6
    }
]

const LEAGUE_TABLE_MAP = {
    TEAM_ID: 0,
    RANK: 2,
    TEAM_NAME: 1,
    PLAYED: 3,
    WIN: 4,
    DRAW: 5,
    LOSE: 6,
    GOAL_DIFFERENCE: 7,
    POINTS: 8
}

const LEAGUE_FORM_MAP = {
    OVERALL: 0,
    HOME_TEAM: 1,
    AWAY_TEAM: 2
}

const LEAGUE_FORM_ROW_MAP = {
    RESULT: 4,
    EVENT_NAME: 7,
    EVENT_DATE: 1
}

const LEAGUE_FORM_ROWS_LIMIT = {
    OVERALL: 5,
    HOME_AWAY: 5
}

const VIEW_STATUS = {
    LOADING: 'LOADING',
    ERROR: 'ERROR',
    TEAM: 'TEAM',
    PENDING: 'PENDING'
}

const AVERAGE_STATISTICS_ROW_FORMAT_MAPPING = {
    2: "{0}'",
    3: "{0}'",
}

export {
    EVENT_DETAIL_MAP,
    AVERAGE_STATISTICS_ROW_TITLE_MAP,
    AVERAGE_STATISTICS_ROW_FORMAT_MAPPING,
    LEAGUE_TABLE_MAP,
    LEAGUE_FORM_MAP,
    LEAGUE_FORM_ROW_MAP,
    LEAGUE_FORM_ROWS_LIMIT,
    VIEW_STATUS
}


// WEBPACK FOOTER //
// ./src/app/components/StatsPageComponent/constants.js